import React from 'react';
import styled, { keyframes } from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  moon_crater: {
    position: 'absolute',
    content: '',
    borderRadius: '100%',
    background: 'linear - gradient(90deg, rgba(122, 122, 122, 1) 38 %, rgba(195, 195, 195, 1) 100 %)',
    opacity: '0.6',
  },
  moon_crater1: {
    top: '250px',
    left: '500px',
    width: '60px',
    height: '180px',
  },
  moon_crater2: {
    top: '650px',
    left: '340px',
    width: '40px',
    height: '80px',
    transform: 'rotate(55deg)',
  },
  moon_crater3: {
    top: -'20px',
    left: '40px',
    width: '65px',
    height: '120px',
    transform: 'rotate(250deg)',
  },

}));

const Container = styled.div`
  height: 100%;
  width: 100%;
  margin: 0px;
  background: linear-gradient(90deg, rgba(47,54,64,1) 23%, rgba(24,27,32,1) 100%);
`;

const Moon = styled.div`
  background: linear-gradient(90deg, rgba(208,208,208,1) 48%, rgba(145,145,145,1) 100%);
  position: absolute;
  top: -100px;
  left: -300px;
  width: 900px;
  height: 900px;
  content: '';
  border-radius: 100%;
  box-shadow: 0px 0px 30px -4px rgba(0,0,0,0.5);
`;

const MoonCrater = styled.div`
  position: absolute;
  content: '';
  border-radius: 100%;
  background: linear-gradient(90deg, rgba(122,122,122,1) 38%, rgba(195,195,195,1) 100%);
  opacity: 0.6;
`;

const MoonCrater1 = styled.div`
  top: 250px;
  left: 500px;
  width: 60px;
  height: 180px;
`;

const MoonCrater2 = styled.div`
  top: 650px;
  left: 340px;
  width: 40px;
  height: 80px;
  transform: rotate(55deg);
`;

const MoonCrater3 = styled.div`
  top: -20px;
  left: 40px;
  width: 65px;
  height: 120px;
  transform: rotate(250deg);
`;

const shimmer = keyframes`
  from { opacity: 0; }
  to { opacity: 0.7; }
`;

const Star = styled.div`
  background: grey;
  position: absolute;
  width: 5px;
  height: 5px;
  content: '';
  border-radius: 100%;
  transform: rotate(250deg);
  opacity: 0.4;
  animation-name: ${shimmer};
  animation-duration: 1.5s;
  animation-iteration-count: infinite;
  animation-direction: alternate;
`;

const Star1 = styled.div`
  top: 40 %;
  left: 50 %;
  animation - delay: 1s;
`;

const Star2 = styled.div`
  top: 60 %;
  left: 90 %;
  animation - delay: 3s;
`;

const Star3 = styled.div`
  top: 10 %;
  left: 70 %;
  animation - delay: 2s;
`;

const Star4 = styled.div`
  top: 90 %;
  left: 40 %;
`;

const Star5 = styled.div`
  top: 20 %;
  left: 30 %;
  animation - delay: 0.5s;
`;


const Error = styled.div`
  position: absolute;
  left: 100px;
  top: 400px;
  transform: translateY(-60 %);
  font - family: 'Righteous', cursive;
  color: #363e49;
`;

const ErrorTitle = styled.div`
  font - size: 10em;
`;

const ErrorSubtitle = styled.div`
  font - size: 2em;
`;

const ErrorDescription = styled.div`
  opacity: 0.5;
`;

const ErrorButton = styled.div`
  min - width: 7em;
  margin - top: 3em;
  margin - right: 0.5em;
  padding: 0.5em 2em;
  outline: none;
  border: 2px solid #2f3640;
  background - color: transparent;
  border - radius: 8em;
  color: #576375;
  cursor: pointer;
  transition - duration: 0.2s;
  font - size: 0.75em;
  font - family: 'Righteous', cursive;
  & hover : {
    color: #21252c;
  }
`;

const Astronaut = styled.div`
  position: absolute;
  width: 185px;
  height: 300px;
  left: 70 %;
  top: 50 %;
  transform: translate(-50 %, -50 %) rotate(20deg) scale(1.2);
`;

const AstronautHead = styled.div`
  background - color: white;
  position: absolute;
  top: 60px;
  left: 60px;
  width: 60px;
  height: 60px;
  content: '';
  border - radius: 2em;
`;

const AstronautHeadVisorFlare1 = styled.div`
  background - color: #7f8fa6;
  position: absolute;
  top: 28px;
  left: 40px;
  width: 10px;
  height: 10px;
  content: '';
  border - radius: 2em;
  opacity: 0.5;
`;

const AstronautHeadVisorFlare2 = styled.div`
  background - color: #718093;
  position: absolute;
  top: 40px;
  left: 38px;
  width: 5px;
  height: 5px;
  content: '';
  border - radius: 2em;
  opacity: 0.3;
`;

const AstronautBackpack = styled.div`
  background - color: #bfbfbf;
  position: absolute;
  top: 90px;
  left: 47px;
  width: 86px;
  height: 90px;
  content: '';
  border - radius: 8px;
`;

const AstronautBody = styled.div`
  background - color: #e6e6e6;
  position: absolute;
  top: 115px;
  left: 55px;
  width: 70px;
  height: 80px;
  content: '';
  border - radius: 8px;
`;

const AstronautBodyChest = styled.div`
  background - color: #d9d9d9;
  position: absolute;
  top: 140px;
  left: 68px;
  width: 45px;
  height: 25px;
  content: '';
  border - radius: 6px;
`;

const AstronautArmLeft1 = styled.div`
  background - color: #e6e6e6;
  position: absolute;
  top: 127px;
  left: 9px;
  width: 65px;
  height: 20px;
  content: '';
  border - radius: 8px;
  transform: rotate(-30deg);
`;

const AstronautArmLeft2 = styled.div`
  background - color: #e6e6e6;
  position: absolute;
  top: 102px;
  left: 7px;
  width: 20px;
  height: 45px;
  content: '';
  border - radius: 8px;
  transform: rotate(-12deg);
  border - top - left - radius: 8em;
  border - top - right - radius: 8em;
`;

const AstronautArmRight1 = styled.div`
  background - color: #e6e6e6;
  position: absolute;
  top: 113px;
  left: 100px;
  width: 65px;
  height: 20px;
  content: '';
  border - radius: 8px;
  transform: rotate(-10deg);
`;

const AstronautArmRight2 = styled.div`
  background - color: #e6e6e6;
  position: absolute;
  top: 78px;
  left: 141px;
  width: 20px;
  height: 45px;
  content: '';
  border - radius: 8px;
  transform: rotate(-10deg);
  border - top - left - radius: 8em;
  border - top - right - radius: 8em;
`;

const AstronautArmThumbLeft = styled.div`
  background - color: #e6e6e6;
  position: absolute;
  top: 110px;
  left: 21px;
  width: 10px;
  height: 6px;
  content: '';
  border - radius: 8em;
  transform: rotate(-35deg);
`;

const AstronautArmThumbRight = styled.div`
  background - color: #e6e6e6;
  position: absolute;
  top: 90px;
  left: 133px;
  width: 10px;
  height: 6px;
  content: '';
  border - radius: 8em;
  transform: rotate(20deg);
`;

const AstronautWristLeft = styled.div`
  background - color: #e67e22;
  position: absolute;
  top: 122px;
  left: 6.5px;
  width: 21px;
  height: 4px;
  content: '';
  border - radius: 8em;
  transform: rotate(-15deg);
`;

const AstronautWristRight = styled.div`
  background - color: #e67e22;
  position: absolute;
  top: 98px;
  left: 141px;
  width: 21px;
  height: 4px;
  content: '';
  border - radius: 8em;
  transform: rotate(-10deg);
`;

const AstronautLegLeft = styled.div`
  background - color: #e6e6e6;
  position: absolute;
  top: 188px;
  left: 50px;
  width: 23px;
  height: 75px;
  content: '';
  transform: rotate(10deg);
`;

const AstronautLegRight = styled.div`
  background - color: #e6e6e6;
  position: absolute;
  top: 188px;
  left: 108px;
  width: 23px;
  height: 75px;
  content: '';
  transform: rotate(-10deg);
`;

const AstronautFootLeft = styled.div`
  background - color: white;
  position: absolute;
  top: 240px;
  left: 43px;
  width: 28px;
  height: 20px;
  content: '';
  transform: rotate(10deg);
  border - radius: 3px;
  border - top - left - radius: 8em;
  border - top - right - radius: 8em;
  border - bottom: 4px solid #e67e22;
`;

const AstronautFootRight = styled.div`
  background - color: white;
  position: absolute;
  top: 240px;
  left: 111px;
  width: 28px;
  height: 20px;
  content: '';
  transform: rotate(-10deg);
  border - radius: 3px;
  border - top - left - radius: 8em;
  border - top - right - radius: 8em;
  border - bottom: 4px solid #e67e22;
`;


export default () => (
  <Container />
);
